import { render, staticRenderFns } from "./IconBetaAccountBox.vue?vue&type=template&id=4e7a378e&"
import script from "./IconBetaAccountBox.vue?vue&type=script&lang=ts&"
export * from "./IconBetaAccountBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports